import React from "react";

const ArrowBackIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.7651 15.0434L1.3581 8.0394L8.7651 1.03613"
      stroke="currentColor"
      strokeWidth="1.4036"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1719 8.03931H4.3586"
      stroke="currentColor"
      strokeWidth="1.4036"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowBackIcon;
